export { default as NotificationsContainer } from './web/NotificationsContainer';
